module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"_0_2_6_link__link___O8crE","link_iconMargin_left":"_0_2_6_link__link_iconMargin_left___30i96","link_iconMargin_right":"_0_2_6_link__link_iconMargin_right___2Zj_m","link_underlined_always":"_0_2_6_link__link_underlined_always___1CkJ8","link_underlined_hover":"_0_2_6_link__link_underlined_hover___GIdxC"};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Link", function() { return /* reexport */ Link; });

// EXTERNAL MODULE: external "tslib"
var external_tslib_ = __webpack_require__(1);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(3);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// EXTERNAL MODULE: ./src/Link/link.scss
var Link_link = __webpack_require__(0);
var link_default = /*#__PURE__*/__webpack_require__.n(Link_link);

// CONCATENATED MODULE: ./src/Link/Link.tsx




/**
 * Компонент ссылки.
 * Используя его, не забываем заворачивать внутрений текст в ui-text.
 * Если ссылка должна выглядеть как текст/текст+иконка - прокидываем в неё Text и Icon,
 * задаём стили для наведения из родителя.
 * Если ссылка должна быть кастомной (карточка товараб etc.) - передаём div с наполнением,
 * снимаем underlined, задаём стили ховера из родителя.
 */
function Link(_a) {
    var _b, _c, _d, _e;
    var children = _a.children, _f = _a.underlined, underlined = _f === void 0 ? 'always' : _f, _g = _a.iconMargin, iconMargin = _g === void 0 ? 'left' : _g, className = _a.className, props = Object(external_tslib_["__rest"])(_a, ["children", "underlined", "iconMargin", "className"]);
    return (external_react_default.a.createElement("a", Object(external_tslib_["__assign"])({ className: external_classnames_default()(link_default.a.link, className, (_b = {}, _b[link_default.a.link_underlined_always] = underlined === 'always', _b), (_c = {}, _c[link_default.a.link_underlined_hover] = underlined === 'hover', _c), (_d = {}, _d[link_default.a.link_iconMargin_left] = iconMargin === 'left', _d), (_e = {}, _e[link_default.a.link_iconMargin_right] = iconMargin === 'right', _e)), rel: "noreferrer noopener" }, props), children));
}

// CONCATENATED MODULE: ./src/Link/index.ts


// CONCATENATED MODULE: ./index.ts



/***/ })
/******/ ]);